import React, {useEffect, useState} from "react";
import {AutoComplete, Button, Col, Form, Input, message, Modal, Row, Space, Switch} from "antd";
import {CloseCircleOutlined, DeleteOutlined, EditFilled, MinusCircleFilled, PlusCircleFilled} from "@ant-design/icons";
import {apiClient} from "../../../../services/ApiClient";
const { confirm } = Modal;

export default function DriverSection({onSelect, value}) {
  const mapRecord = (record) => {
    record.displayName = `${record.surname} ${record.name} ${record.patronymic} (${record.license})`;
    return {
      key: record.id,
      value: record.displayName,
      record: record
    };
  };

  let [record, setRecord] = useState(value ? mapRecord(value) : null);
  let [options, setOptions] = useState([]);
  let [formVisible, setFormVisible] = useState(false);
  let [loading, setLoading] = useState(false);
  let [enableSave, setEnableSave] = useState(false);
  let [form] = Form.useForm();

  useEffect(() => {
    setRecord(value);

    if(!value) {
      let save = false;
      if(localStorage.getItem(`DriverSection.enableSave`) === null) {
        save = false;
      } else {
        save = localStorage.getItem('DriverSection.enableSave') === "true";
        if(save) {
          const rec = localStorage.getItem('DriverSection.record');
          if(rec) {
            updateRecord(JSON.parse(rec));
          }
        }
      }
      setEnableSave(save);
    }
  }, [value]);

  const updateEnableSave = (checked) => {
    localStorage.setItem('DriverSection.enableSave', String(checked));
    if(!checked) {
      localStorage.removeItem('DriverSection.record');
    } else if(record) {
      localStorage.setItem('DriverSection.record', JSON.stringify(record));
    }
    setEnableSave(checked);
  };

  const updateRecord = rec => {
    if(rec) {
      localStorage.setItem('DriverSection.record', JSON.stringify(rec));
    } else {
      localStorage.removeItem('DriverSection.record');
    }
    setRecord(rec);
    onSelect(rec);
    setOptions([]);
  };

  const search = (val) => {
    apiClient.searchDirectoryRecord('driver', val)
      .then(res => {
        if(res.success) {
          setOptions(res.records.map(e => mapRecord(e)));
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error("Не удалось выполнить поиск")
      });
  };

  const create = (args) => {
    console.log({args});
    setLoading(true);
    apiClient.createDirectoryRecord('driver', args)
      .then(res => {
        if(res.success) {
          form.resetFields();
          setFormVisible(false);
          setRecord(mapRecord(res.record).record);
          onSelect(res.record);
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const remove = () => {
    if(!record) {
      return;
    }
    apiClient.removeDirectoryRecord('driver', record.id)
      .then(res => {
        if(res.success) {
          setRecord(null);
          setOptions([]);
          onSelect(null);
          if(formVisible) {
            form.resetFields();
          }
        } else {
          message.error("Ошибка");
        }
      })
      .catch(err => {
        message.error(err);
      });
  };

  const update = (args) => {
    setLoading(true);
    apiClient.updateDirectoryRecord('driver', record.id, args)
      .then(res => {
        if(res.success) {
          form.resetFields();
          setFormVisible(false);
          setRecord(mapRecord(res.record).record);
          onSelect(res.record);
        } else if(res.errorMessage) {
          message.error(res.errorMessage);
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderForm = () => {
    if(!formVisible) {
      return null;
    }
    if(record) {
      form.setFieldsValue({
        "surname": record.surname,
        "name": record.name,
        "snils": record.snils,
        "patronymic": record.patronymic,
        "license": record.license,
        "license_start_dt": record.license_start_dt,
        "license_end_dt": record.license_end_dt,
      });
    }
    return (
      <Form form={form} layout="horizontal" style={{margin: '10px 0'}}
            labelCol={{span: 3}}
            wrapperCol={{span: 10}}
            onFinish={(args) => { record !== null && record.id > 0 ? update(args) : create(args) }}
      >
        <Form.Item
          label="Фамилия"
          name="surname"
          rules={[
            {
              required: true,
              message: 'Укажите Фамилию',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Имя"
          name="name"
          rules={[
            {
              required: true,
              message: 'Укажите Имя',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Отчество"
          name="patronymic"
          rules={[
            {
              required: true,
              message: 'Укажите Отчество',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="СНИЛС"
          name="snils"
          rules={[
            {
              required: true,
              message: 'Укажите СНИЛС',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Серия и номер ВУ"
          name="license"
          rules={[
            {
              required: true,
              message: 'Укажите Серия и номер ВУ',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Дата ВУ"
          name="license_start_dt"
          rules={[
            {
              required: true,
              message: 'Укажите Дата ВУ',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item
          label="Срок ВУ"
          name="license_end_dt"
          rules={[
            {
              required: true,
              message: 'Укажите Срок ВУ',
            },
          ]}
        >
          <Input allowClear={true}/>
        </Form.Item>

        <Form.Item wrapperCol={{span: 10, offset: 3}} style={{textAlign: "right"}}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    );
  };

  const renderSelectedActions = () => {
    return (
      <>
        {formVisible
          ? <Button type="link" icon={<CloseCircleOutlined/>} onClick={() => setFormVisible(false)}/>
          : <Button type="link" icon={<EditFilled/>} onClick={() => setFormVisible(true)}/>}
        <Button type="link"
                style={{color: 'darkred'}}
                icon={<DeleteOutlined/>}
                onClick={() => {
                  confirm({
                    title:  "Удаление",
                    content: "Вы уверены, что хотите удалить запись?",
                    icon: <DeleteOutlined/>,
                    visible: true,
                    onOk() {
                      remove();
                    },
                  })
                }}/>
      </>
    );
  };

  const renderNotSelectedActions = () => (
    formVisible
      ? <Button type="link" icon={<MinusCircleFilled/>} onClick={() => setFormVisible(false)}/>
      : <Button type="link" icon={<PlusCircleFilled/>} onClick={() => setFormVisible(true)}/>
  );

  return (
    <>
      <Row>
        <Col span={3}>
          <h3>Водитель</h3>
        </Col>
        <Col span={10}>
          <AutoComplete
            style={{width: '100%'}}
            options={options}
            onSelect={(val, opt) => { updateRecord(opt.record) }}
            onSearch={search}
            onChange={(val) => {
              if(val === undefined) {
                updateRecord(null);
                if(formVisible) {
                  form.resetFields();
                }
              } else {
                setRecord({displayName: val});
              }
            }}
            value={record ? record.displayName : ""}
            allowClear={true}
            placeholder="Искать водителя..."
          />
        </Col>
        <Col span={1}>
          <Space direction="horizontal">
            {
              record != null && record.id > 0
                ? renderSelectedActions()
                : renderNotSelectedActions()
            }
          </Space>
        </Col>
        <Col span={10} style={{textAlign: 'right'}}>
          <Switch checked={enableSave}
                  checkedChildren="Сохранять"
                  unCheckedChildren="Не сохранять"
                  style={{width: 120}}
                  onChange={(checked, event) => { updateEnableSave(checked) }}/>
        </Col>
      </Row>
      {renderForm()}
    </>
  );
}